import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/topup-close.svg'


const _hoisted_1 = { class: "confirm-popup__wrapper" }
const _hoisted_2 = { class: "confirm-popup__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "confirm-popup__content-wrapper" }
const _hoisted_6 = { class: "confirm-popup__content-info" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "desc"
}
const _hoisted_9 = {
  key: 0,
  class: "confirm-popup__content-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["confirm-popup", { show: _ctx.showPopup }])
  }, [
    _createElementVNode("div", {
      class: "confirm-popup__bg",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hide()))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hide)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "confirm-popup__content-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hide()))
            }, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "title",
                  innerHTML: _ctx.title
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.description), 1))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "content"),
          (_ctx.$slots.actions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "actions")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}